import * as React from 'react';
import { useContext } from 'react';
import FeedbackCardContext from '../context.js';
import { Container, Title, Paragraph } from '../styles.js';

const ConclusionStep = ()=>{
    const { copyConfig  } = useContext(FeedbackCardContext);
    const stepCopy = copyConfig.steps.Conclusion;
    return /*#__PURE__*/ React.createElement(Container, null, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Title, null, stepCopy.title), /*#__PURE__*/ React.createElement(Paragraph, null, stepCopy.subtitle)));
};
var ConclusionStep$1 = ConclusionStep;

export { ConclusionStep$1 as default };
